import React from "react";

export default function ProjectList({ projects }) {
    return (
        <div className="projects-grid">
            {projects.map((proj, index) => (
                <div key={index} className="project-card">
                    <div className="card-image-container">
                        <a href={proj.link} target="_blank" rel="noopener noreferrer" className='project-image-link'>
                            <div 
                                className="project-image" 
                                style={{ backgroundImage: `url(${proj.image})` }}
                                aria-label={`View ${proj.name} project`}
                            />
                            <div className="image-overlay"></div>
                        </a>
                    </div>
                    
                    <div className="card-content">
                        <div className={`project-header ${proj.name === 'Simon Game' ? 'simon-game' : 
                                        proj.name === 'Byte Queens' ? 'byte-queens' : 
                                        ['Tinder for Dogs', 'Operations On Fractions', 
                                         'Rock Paper Scissors User vs Computer', 
                                         'Arithmatic Arranger'].includes(proj.name) ? 'special-project' : ''}`}>
                            <h3>{proj.name}</h3>
                            <div className="project-divider"></div>
                        </div>
                        
                        <div className="project-description">
                            <p>{proj.description}</p>
                        </div>
                        
                        <div className="project-meta">
                            <div className="meta-section">
                                <h4 className="meta-title">Skills</h4>
                                <div className="tags-container">
                                    {proj.topSkills.map((el, skillIndex) => (
                                        <span key={skillIndex} className="skill-tag">{el}</span>
                                    ))}
                                </div>
                            </div>
                            
                            <div className="meta-section">
                                <h4 className="meta-title">Technologies</h4>
                                <div className="tags-container">
                                    {proj.languages.map((el, langIndex) => (
                                        <span key={langIndex} className="tech-tag">{el}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                        
                        <a href={proj.link} target="_blank" rel="noopener noreferrer" className="project-link">
                            View Project <span className="arrow">→</span>
                        </a>
                    </div>
                </div>
            ))}
        </div>
    );
}